import React from 'react';
import { CalendarEvent } from '../../types/calendar';
import { EventPill } from './EventPill';
interface UpcomingEventsListProps {
  events: CalendarEvent[];
}
export function UpcomingEventsList({
  events
}: UpcomingEventsListProps) {
  // Sort events by date
  const sortedEvents = [...events].sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
  // Filter for future events only (mocking by taking the first 5 for now)
  const upcoming = sortedEvents.slice(0, 5);
  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('es-ES', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  };
  return <div className="card p-5 h-full" data-id="element-195">
      <h3 className="text-[16px] font-semibold text-growthly-text mb-4" data-id="element-196">
        Próximos eventos
      </h3>

      {upcoming.length === 0 ? <p className="text-sm text-growthly-muted" data-id="element-197">No hay eventos próximos.</p> : <div className="space-y-4" data-id="element-198">
          {upcoming.map(event => <div key={event.id} className="flex flex-col" data-id="element-199">
              <span className="text-[12px] text-growthly-muted mb-1" data-id="element-200">
                {formatDate(event.start)}
              </span>
              <EventPill event={event} data-id="element-201" />
            </div>)}
        </div>}
    </div>;
}